module.exports = __webpack_public_path__ + "media/images/icons/filled/diff-b6c8bee3ab8a9be2b8065a0c8be6a0c5.svg";